<script>
  import options from './RequestRole.options'
  export default options
</script>

<template>

  <article class="kb-request-role kb-optimizely-forms kb-stafet-step kb-stafet-donation-flow__step">   
    
        <div class="kb-stafet-step__input-wrapper" >

          <h5 class="kb-stafet-step__step-section-title">
            {{ getLabel("requestRoleSectionTitle") }}
          </h5>

          <p class="kb-visually-hidden">{{ getLabel('activitySelectorHelpMessage') }}</p>

            <FormInputDropdown
                isRequired
                fieldName="roleActivity"
                :modelValue="roleActivityId"
                :label="getLabel('activitySelectorLabel')"
                :placeholder="getLabel('activitySelectorPlaceholder')"
                :errorMessageLabel="getLabel('activitySelectorError')"
                :selectOptions="activitySelectOptions"
                :onChangeCallback="(e)=>{handleActivitiesSelector(e)}"
              />
        </div>
  

        <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
     
          <template v-if="roleActivityId">
            <p class="kb-visually-hidden">{{ getLabel('roleSelectorHelpMessage') }}</p>

            <FormInputDropdown
                  isRequired
                  fieldName="role"
                  :modelValue="roleId"
                  :label="getLabel('roleSelectorLabel')"
                  :placeholder="getLabel('roleSelectorPlaceholder')"
                  :errorMessageLabel="getLabel('roleSelectorError')"
                  :selectOptions="roleSelectOptions"
                  :onChangeCallback="(e)=>{handleRoleSelector(e)}"
                />
          </template>
        
          <div v-if="roleActivityId && !roleGroupCheckbox" class="kb-form-input-dropdown kb--js-Group-selector-reset">
            <p class="kb-visually-hidden">{{ getLabel('groupSelectorHelpMessage') }}</p>
            <FormInputDropdown
                  isRequired
                  fieldName="roleGroup"
                  :modelValue="roleGroupId"
                  :label="getLabel('groupSelectorLabel')"
                  :placeholder="getLabel('groupSelectorPlaceholder')"
                  :errorMessageLabel="getLabel('groupSelectorError')"
                  :selectOptions="groupSelectOptions"
                  :onChangeCallback="(e)=>{handleGroupSelector(e)}"
                  :isValidationError="displayError && !roleGroup"
                />
          </div>
          
        </div>
   
      <template v-if="roleActivityId">
        <div class="kb-stafet-step__input-wrapper">

          <FormCheckbox
            fieldName="roleGroupCheckbox"
            modelValue="roleGroupCheckbox"
            :label="getLabel('groupCheckboxLabel')"
            :placeholder="getLabel('groupCheckboxPlaceholder')"
            :errorMessageLabel="getLabel('groupCheckboxError')"
            :onChangeCallback="(e)=>{handleGroupCheckbox(e)}"
        />

        </div>
      </template>

      <template v-if="roleGroupCheckbox">
        <div class="kb-stafet-step__input-wrapper">

          <FormInputTextField
            fieldName="roleGroup"
            :modelValue="roleGroupTextField"
            :label="getLabel('groupTextFieldLabel')"
            :placeholder="getLabel('groupTextFieldPlaceholder')"
            :errorMessageLabel="getLabel('groupTextFieldError')"
            :onChangeCallback="(e)=>{handleGroupTextField(e)}"
            :isValidationError="displayError && !roleGroupTextFieldFilled && !roleGroup"
          />

        </div>
      </template>
      
      <nav class="kb-stafet-flow-actions" v-if="roleId">
        <div class="kb-stafet-flow-actions__buttons-left-wrapper">
          <button class="kb-button kb-button--full-color-spot" v-on:click="handleSubmitRoleRequest">
            {{ getLabel("submitButtonLabel") }}
          </button>
        </div>
      </nav>

  </article>
</template>
